module.exports = __webpack_public_path__ + "static/img/01.f0a8f20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ambient-works/01.png
// module id = 7UOI
// module chunks = 0